import { featureKeys } from '@/api/b2b';
import { queryClient } from '@/lib/react-query';
import { useRealtimeChannelEvents } from '@/hooks/useRealtimeChannelEvents';
import { AuthContext } from '@/providers/auth';
import { useContext } from 'react';

/**
 * Pops new B2B leads into the Open Leads column the instant they arrive: the
 * server broadcasts `b2b.lead-received` to the rep's user-notifications
 * channel; we treat it as a cache-invalidation hint (the poll remains the
 * source of truth) and refresh the b2b lists.
 */
export const useB2bLeadAlerts = () => {
  const { user } = useContext(AuthContext);

  useRealtimeChannelEvents({
    kind: 'private',
    channelName: user ? `user-notifications.${user.user_id}` : '',
    enabled: Boolean(user?.is_b2b),
    events: ['b2b.lead-received', '.b2b.lead-received'],
    handler: () => {
      queryClient.invalidateQueries({ queryKey: featureKeys.all });
    },
  });
};
